import { Link, Navigate, useLocation } from "react-router-dom";
import { getDriverSession, saveDriverSession } from "../lib/driverSession";

export default function DriverShell({ children, onLogout }) {
  const driver = getDriverSession();
  const location = useLocation();
  if (!driver?.auth_token) return <Navigate to="/delivery/login" replace />;

  function logout() {
    saveDriverSession(null);
    onLogout?.();
    window.location.assign("/delivery/login");
  }

  return (
    <main className={`driver-app${localStorage.getItem("dh_driver_dark") === "true" ? " is-dark" : ""}`}>
      <header className="driver-header">
        <a href="/delivery"><img src="/assets/img/logos/logo.png" alt="Delivery Huaraz" /></a>
        <div>
          <small>PANEL DE REPARTO</small>
          <b>{driver.name}</b>
        </div>
        <button type="button" onClick={logout}>Salir</button>
      </header>
      <nav className="driver-nav" aria-label="Panel del motorizado">
        {[
          ["/delivery/orders?tab=new", "⌁", "Servicios", location.pathname === "/delivery/orders" && !["active", "pickedup"].includes(new URLSearchParams(location.search).get("tab"))],
          ["/delivery/orders?tab=active", "▦", "Aceptados", location.pathname === "/delivery/orders" && new URLSearchParams(location.search).get("tab") === "active"],
          ["/delivery/orders?tab=pickedup", "▣", "Recogidos", location.pathname === "/delivery/orders" && new URLSearchParams(location.search).get("tab") === "pickedup"],
          ["/delivery/account", "♙", "Cuenta", location.pathname === "/delivery/account"],
        ].map(([to, icon, label, active]) => (
          <Link className={active ? "active" : ""} to={to} key={to}>
            <span aria-hidden="true">{icon}</span><small>{label}</small>
          </Link>
        ))}
      </nav>
      <div className="driver-content">{children}</div>
    </main>
  );
}
